import React, { createContext, useContext } from "react";
import { IConfiguration, IUser } from "interfaces";

interface ProvidedValueType {
  // data
  user: IUser;
  setUser: (user: IUser) => void;
  configurations: IConfiguration[];
  setConfigurations: (menus: IConfiguration[]) => void;
}

const initialState = {
  obj: null,
  empty: "",
  array: [],
};

export const DataContext = createContext<ProvidedValueType>({
  // data
  user: initialState.obj,
  setUser: () => {},
  configurations: initialState.array,
  setConfigurations: () => {},
});

interface Props {
  children?: React.ReactNode;
}

export const DataProvider = React.memo<Props>(({ children }) => {
  // const [filter, setFilter] = React.useState<string>(initialState.empty);
  const [user, setUser] = React.useState<IUser>(initialState.obj);
  const [configurations, setConfigurations] = React.useState<IConfiguration[]>(
    initialState.array
  );

  const MemoizedValue = React.useMemo(() => {
    const value: ProvidedValueType = {
      user,
      setUser,
      configurations,
      setConfigurations,
    };
    return value;
  }, [user, setUser, configurations, setConfigurations]);

  return (
    <DataContext.Provider value={MemoizedValue}>
      {children}
    </DataContext.Provider>
  );
});

export const useData = () => useContext(DataContext);
